import React, { useState } from "react";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import moment, { Moment } from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";

interface PredefinedDateRangesProps {
  onDateRangeChange?: (start: Date | null, end: Date | null) => void;
}

const PredefinedDateRanges: React.FC<PredefinedDateRangesProps> = ({
  onDateRangeChange = () => {},
}) => {
  const [state, setState] = useState({
    start: moment().subtract(6, "days"),
    end: moment(),
  });

  const { start, end } = state;

  const handleCallback = (start: Moment, end: Moment) => {
    setState({ start, end });
    onDateRangeChange(start.toDate(), end.toDate());
  };

  const label = `${start.format("DD-MM-YYYY")} - ${end.format("DD-MM-YYYY")}`;

  return (
    <DateRangePicker
      initialSettings={{
        startDate: start.toDate(),
        endDate: end.toDate(),
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [
            moment().subtract(1, "days").toDate(),
            moment().subtract(1, "days").toDate(),
          ],
          "Last 7 Days": [
            moment().subtract(6, "days").toDate(),
            moment().toDate(),
          ],
          "Last 30 Days": [
            moment().subtract(29, "days").toDate(),
            moment().toDate(),
          ],
          "This Month": [
            moment().startOf("month").toDate(),
            moment().endOf("month").toDate(),
          ],
          "Last Month": [
            moment().subtract(1, "month").startOf("month").toDate(),
            moment().subtract(1, "month").endOf("month").toDate(),
          ],
        },
        locale: {
          format: "DD-MM-YYYY",
        },
      }}
      onCallback={handleCallback}
    >
      <div className="form-control daterangepicker-input">
        <i className="ti ti-calendar me-2"></i>
        <span>{label}</span>
        <i className="ti ti-chevron-down ms-2"></i>
      </div>
    </DateRangePicker>
  );
};

export default PredefinedDateRanges;
